module.exports = "https://static.wmbcdn.com/uniweb/images/1ac32c1bba15d92cc041c93fc158d07f.svg";